import * as fromDatatype from "../datatype-library/index";

export interface bl_del_job_shipment_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    shipment_hdr_guid: fromDatatype.GuidDataFieldInterface;
    job_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_code: fromDatatype.TextDatatypeInterface;
    item_name: fromDatatype.TextDatatypeInterface;
    recipient_name: fromDatatype.TextDatatypeInterface;
    recipient_id: fromDatatype.TextDatatypeInterface;
    recipient_contact: fromDatatype.TextDatatypeInterface;
    proof_of_received: fromDatatype.TextDatatypeInterface;
    quantity: fromDatatype.NumericDatatypeInterface;
    qty_to_deliver: fromDatatype.NumericDatatypeInterface;
    qty_delivered: fromDatatype.NumericDatatypeInterface;
    installation_duration_minute: fromDatatype.IntegerDatatypeInterface;
    delivery_status: fromDatatype.VarcharDatatypeInterface;
    delivery_logic: fromDatatype.VarcharDatatypeInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    process_status_name: fromDatatype.VarcharDatatypeInterface;
    process_resolution_guid: fromDatatype.GuidDataFieldInterface;
    process_resolution_code: fromDatatype.VarcharDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    server_doc_2: fromDatatype.VarcharDatatypeInterface;
    server_doc_3: fromDatatype.VarcharDatatypeInterface;
    server_doc_4: fromDatatype.VarcharDatatypeInterface;
    server_doc_5: fromDatatype.VarcharDatatypeInterface;
    obj_type: fromDatatype.TextDatatypeInterface;
    namespace: fromDatatype.TextDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.TextDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    proof_rct_name: fromDatatype.VarcharDatatypeInterface;
    proof_rct_id: fromDatatype.VarcharDatatypeInterface;
    proof_rct_phone: fromDatatype.VarcharDatatypeInterface;
    proof_rct_remarks: fromDatatype.VarcharDatatypeInterface;
    collection_amount: fromDatatype.NumericDatatypeInterface;
    reason: fromDatatype.VarcharDatatypeInterface;
}

export class bl_del_job_shipment_link_RowClass implements bl_del_job_shipment_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    shipment_hdr_guid: fromDatatype.GuidDataFieldInterface;
    job_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_code: fromDatatype.TextDatatypeInterface;
    item_name: fromDatatype.TextDatatypeInterface;
    recipient_name: fromDatatype.TextDatatypeInterface;
    recipient_id: fromDatatype.TextDatatypeInterface;
    recipient_contact: fromDatatype.TextDatatypeInterface;
    proof_of_received: fromDatatype.TextDatatypeInterface;
    quantity: fromDatatype.NumericDatatypeInterface;
    qty_to_deliver: fromDatatype.NumericDatatypeInterface;
    qty_delivered: fromDatatype.NumericDatatypeInterface;
    installation_duration_minute: fromDatatype.IntegerDatatypeInterface;
    delivery_status: fromDatatype.VarcharDatatypeInterface;
    delivery_logic: fromDatatype.VarcharDatatypeInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    process_status_name: fromDatatype.VarcharDatatypeInterface;
    process_resolution_guid: fromDatatype.GuidDataFieldInterface;
    process_resolution_code: fromDatatype.VarcharDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    server_doc_2: fromDatatype.VarcharDatatypeInterface;
    server_doc_3: fromDatatype.VarcharDatatypeInterface;
    server_doc_4: fromDatatype.VarcharDatatypeInterface;
    server_doc_5: fromDatatype.VarcharDatatypeInterface;
    obj_type: fromDatatype.TextDatatypeInterface;
    namespace: fromDatatype.TextDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.TextDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    proof_rct_name: fromDatatype.VarcharDatatypeInterface;
    proof_rct_id: fromDatatype.VarcharDatatypeInterface;
    proof_rct_phone: fromDatatype.VarcharDatatypeInterface;
    proof_rct_remarks: fromDatatype.VarcharDatatypeInterface;
    collection_amount: fromDatatype.NumericDatatypeInterface;
    reason: fromDatatype.VarcharDatatypeInterface;
}
